"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "extractComponentInformationFromMeta", {
  enumerable: true,
  get: function get() {
    return _informator.extractComponentInformationFromMeta;
  }
});
Object.defineProperty(exports, "hbsSyntax", {
  enumerable: true,
  get: function get() {
    return _hbsUtils.syntax;
  }
});
Object.defineProperty(exports, "parseScriptFile", {
  enumerable: true,
  get: function get() {
    return _jsUtils.parseScriptFile;
  }
});
Object.defineProperty(exports, "processJSFile", {
  enumerable: true,
  get: function get() {
    return _jsUtils.processJSFile;
  }
});
Object.defineProperty(exports, "processTemplate", {
  enumerable: true,
  get: function get() {
    return _hbsUtils.processTemplate;
  }
});
Object.defineProperty(exports, "rebelObject", {
  enumerable: true,
  get: function get() {
    return _informator.rebelObject;
  }
});

var _jsUtils = require("./utils/js-utils");

var _hbsUtils = require("./utils/hbs-utils");

var _informator = require("./utils/informator");